import React from 'react';

const AsyncUserActivityLog = React.lazy(() => import('./UserActivityLogContainer'));

export const UserActivityLog = () => {
  return <AsyncUserActivityLog />;
};
